import { render } from "./ProcedureCard.vue?vue&type=template&id=1a9dd5a0&scoped=true"
import script from "./ProcedureCard.vue?vue&type=script&lang=js"
export * from "./ProcedureCard.vue?vue&type=script&lang=js"

import "./ProcedureCard.vue?vue&type=style&index=0&id=1a9dd5a0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9dd5a0"]])

export default __exports__